import { useEffect } from 'react'
import { classes, stylesheet, style } from 'typestyle'
import { useNavigate } from 'react-router-dom'

/* Hooks ======================================================================================== */
import useCounter from '../../../../__aeki__/hooks/use-counter'
import useValue from '../../../../__aeki__/hooks/use-value'

/* Components =================================================================================== */
import { Box } from '../../../../__aeki__/components/box/box.component'
import { Button } from '../../../../__aeki__/components/button'
import { CarouselItem } from './carousel-item'
import { Heading } from '../../../../__aeki__/components/text/heading.component'
import { Text } from '../../../../__aeki__/components/text/text.component'

/* Modals ======================================================================================= */
import '../../../../modals/childcare'
import '../../../../modals/childcare-contact'

/* Styles ======================================================================================= */
import { carouselClass } from './carousel.class'
import { createCustomMediaQuery } from '../../../../__aeki__/components/style-class/style-class.utils'
import { pt0 } from '../../../../__aeki__/styles/styleset/padding/pt0'
import { mr4 } from '../../../../__aeki__/styles/styleset/margin/mr4'
import { ml4 } from '../../../../__aeki__/styles/styleset/margin/ml4'
import { mr8 } from '../../../../__aeki__/styles/styleset/margin/mr8'
import { hide } from '../../../../__aeki__/styles/styleset/hide/hide'
import { flex } from '../../../../__aeki__/styles/styleset/flex/flex'
import { f19i } from '../../../../__aeki__/styles/styleset/font-size/f19i'
import { mb12 } from '../../../../__aeki__/styles/styleset/margin/mb12'
import { Line } from '../../../../__aeki__/components/line'
import { mb8 } from '../../../../__aeki__/styles/styleset/margin/mb8'
import { mt8 } from '../../../../__aeki__/styles/styleset/margin/mt8'
import { mt12 } from '../../../../__aeki__/styles/styleset/margin/mt12'
import { mt4 } from '../../../../__aeki__/styles/styleset/margin/mt4'
import { p12 } from '../../../../__aeki__/styles/styleset/padding/p12'

const CaraouselColumns = [
  {
    maxWidth: null,
    minWidth: 1488,
    column: 3,
  },
  {
    maxWidth: 1488,
    minWidth: 1116,
    column: 2,
  },
  {
    maxWidth: 1116,
    minWidth: 768,
    column: 1,
  },
  {
    maxWidth: 768,
    minWidth: null,
    column: 1,
  },
]

export const Carousel = (props: any) => {
  const { columns, customColums = CaraouselColumns, isSpaced, name, items = [], refresh } = props

  const history = useNavigate()
  const [counter, $counter] = useCounter(0, { min: 0, max: items.length - 1, loop: true })
  const [width, $width] = useValue()
  const [incrementSize, $incrementSize] = useValue()

  const { base, baseThemed } = carouselClass.setProps({
    columns,
    customColums,
    isSpaced,
  })

  useEffect(() => {
    function updateSize() {
      $counter.reset()
    }

    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  useEffect(() => {
    if (customColums) {
      customColums.map((item: any) => {
        let mediaQueryList

        if (item.maxWidth && item.minWidth) {
          mediaQueryList = window.matchMedia(
            `(max-width: ${item.maxWidth}px) and (min-width: ${item.minWidth}px)`,
          )
        } else if (item.maxWidth) {
          mediaQueryList = window.matchMedia(`(max-width: ${item.maxWidth}px)`)
        } else {
          mediaQueryList = window.matchMedia(`(min-width: ${item.minWidth}px)`)
        }

        function screenTest(e: any) {
          if (e.matches) {
            $counter.reset()
            $incrementSize.set(item.column)
          }
        }

        screenTest(mediaQueryList)

        mediaQueryList.addListener(screenTest)
      })
    }
  }, customColums)

  useEffect(() => {
    if (incrementSize === undefined) return
    const temp = incrementSize * Math.ceil(items.length / incrementSize)

    if (temp !== incrementSize) {
      $counter.setMax(incrementSize * Math.ceil(items.length / incrementSize) - 1)
    }
  }, [items, incrementSize])

  useEffect(() => {
    const parent = document.getElementById(`www-carousel-${name}`)
    const current = document.getElementById(`www-carousel-item-${name}-0`)

    if (current && parent) {
      const boundingRect = current.getBoundingClientRect()
      parent.scrollLeft = boundingRect.width * counter
    }
  }, [counter])

  useEffect(() => {
    if (items.length > 0 && incrementSize) {
      const number = incrementSize * Math.ceil(items.length / incrementSize)

      $width.set(number - items.length)
    }
  }, [items])

  const decrement = () => {
    $counter.decrement(incrementSize)
  }
  const increment = () => {
    $counter.increment(incrementSize)
  }

  return (
    <Box className={pt0} baseline="none">
      <Box baseline="none" alignBottom column spaceBetween>
        <Box flex alignCenterY>
          <Heading size="xs" semiBold>
            Activities near by
          </Heading>
        </Box>
        <Box baseline="none" alignCenterY column>
          <Text className={classes(STYLES.containerCarouselText, mr4)} size="lg">
            <CurrentPage counter={counter} total={items.length} customColums={customColums} />
            <Text className={classes(ml4, mr4)}>/</Text>
            <TotalPage counter={counter} total={items.length} customColums={customColums} />
          </Text>
          <Box baseline="none" column>
            <Box className={mr8} baseline="none">
              <Prev onClick={decrement} />
            </Box>
            <Next onClick={increment} />
          </Box>
        </Box>
      </Box>
      <Line className={classes(mt8, mb8)} />
      <Text className={mb12} size="lg">
        Something more with the childcare? Here are some sport activities you can find near by
      </Text>
      <div
        className={classes('www-carousel', base, baseThemed, mt12)}
        id={`www-carousel-${name}`}
        style={{ gap: 16 }}
      >
        {items.map((ccp: any, key: any) => {
          return (
            <CarouselItem key={key} id={`www-carousel-item-${name}-${key}`}>
              <a
                href={ccp.body.generalInformation.website}
                onClick={() => {
                  ;(window as any)?.gtag?.('event', `near-activity-click-${ccp.id}`)
                }}
              >
                <Box row className={STYLES.item}>
                  <Box
                    style={{
                      backgroundImage: `url(${ccp.body.generalInformation.imageUrl})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                    rounded
                    className={STYLES.imageCardItem}
                  />
                  <Text className={mt8} size="lg">
                    {ccp.body.generalInformation.name}
                  </Text>
                </Box>
              </a>
            </CarouselItem>
          )
        })}
        {incrementSize > 1 && (
          <div
            className={style({
              flex: `0 0 ${(1 / incrementSize) * 100 * width}%`,
              maxWidth: `calc(${(1 / incrementSize) * 100 * width}% - 0px)`,
            })}
          />
        )}
      </div>
    </Box>
  )
}

const roundToColumn = (column: number, value: number) => {
  return column * Math.ceil(value / column)
}

const CurrentPage = (props: any) => {
  const { counter, total, customColums } = props

  const styleContents = customColums
    .map((item: any) => {
      const page = Number(counter / total || 0)
      const _total = roundToColumn(item.column, total || 0) / item.column
      const current = `${Math.trunc(_total * page + 1)} `

      if (!item.maxWidth) {
        return style({
          display: 'initial !important',
          $nest: {
            '&:before': {
              content: `'${current}'`,
            },
          },
        })
      }

      return style({
        $nest: {
          ...createCustomMediaQuery({
            maxWidth: item.maxWidth,
            style: {
              display: 'initial !important',
              $nest: {
                '&:before': {
                  content: `'${current}'`,
                },
              },
            },
          }),
        },
      })
    })
    .join(' ')

  return <div className={classes(hide, styleContents)} />
}

const TotalPage = (props: any) => {
  const { total, customColums } = props

  const styleContents = customColums
    .map((item: any) => {
      return style({
        $nest: {
          ...createCustomMediaQuery({
            maxWidth: item.maxWidth,
            style: {
              display: 'initial !important',
              $nest: {
                '&:before': {
                  content: `'${roundToColumn(item.column, total || 0) / item.column}'`,
                },
              },
            },
          }),
        },
      })
    })
    .join(' ')

  return <div className={classes(flex, styleContents)} />
}

const Prev = (props: any) => {
  const { onClick } = props

  return (
    <Button
      size="md"
      icon={<span className={classes('material-icons-two-tone', f19i)}>keyboard_arrow_left</span>}
      onClick={onClick}
      ariaLabel={'Previous Page'}
      border
    />
  )
}

const Next = (props: any) => {
  const { onClick } = props

  return (
    <Button
      size="md"
      icon={<span className={classes('material-icons-two-tone', f19i)}>keyboard_arrow_right</span>}
      onClick={onClick}
      ariaLabel={'Next Page'}
      border
    />
  )
}

const STYLES = stylesheet({
  containerCarouselText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    $nest: {
      '*': {
        fontSize: 15,
        color: 'rgb(120, 120, 120)',
        letterSpacing: 2.5,
      },
    },
  },
  imageCardItem: {
    height: 200,
    $nest: {
      ...createCustomMediaQuery({ maxWidth: 1488, style: { height: 280 } }),
      ...createCustomMediaQuery({ maxWidth: 900, style: { height: 320 } }),
      ...createCustomMediaQuery({ maxWidth: 768, style: { height: 360 } }),
    },
  },
  item: {
    cursor: 'pointer',
    transition: '.2s all ease-in-out',
    $nest: {
      '&:hover': {
        $nest: {
          span: {
            color: '#4173ed',
          },
        },
      },
    },
  },
})
